jQuery.validator.addMethod(
    'multiemails',
    function (value, element) {
        if (this.optional(element))
            // return true on optional element
            return true;
        var emails = value.split(/[;,]+/); // split element by , and ;
        valid = true;
        for (var i in emails) {
            value = emails[i];
            valid = valid && jQuery.validator.methods.email.call(this, $.trim(value), element);
        }
        return valid;
    },
    'Not a valid email address combination'
);

jQuery.validator.addMethod(
    'cidraddr',
    function (value, element) {
        return (
            this.optional(element) ||
            /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\/((?:8)|(?:9)|(?:[1-2][0-9])|(?:30)|(?:31)|(?:32))$/.test(
                value
            )
        );
    },
    'Please enter a valid CIDR Address!'
);
jQuery.validator.addMethod(
    'ip_or_fqdn',
    function (value, element) {
        return (
            this.optional(element) ||
            /^((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])||(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9]))$/.test(
                value
            )
        );
    },
    'Please enter a valid IP Address OR FQDN!'
);
jQuery.validator.addMethod(
    'ipaddr',
    function (value, element) {
        return (
            this.optional(element) ||
            /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/.test(
                value
            )
        );
    },
    'Please enter a valid IP Address!'
);
jQuery.validator.addMethod(
    'ospfarea',
    function (value, element) {
        return this.optional(element) || /^0\.0\.0\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/.test(value);
    },
    'Please enter a Area ID in the form of 0.0.0.# where # is your Area ID'
);
jQuery.validator.addMethod(
    'netmask',
    function (value, element) {
        return (
            this.optional(element) ||
            /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/.test(
                value
            )
        );
    },
    'Please enter a valid Subnet Mask!'
);
jQuery.validator.addMethod(
    'ipgateway',
    function (value, element) {
        return (
            this.optional(element) ||
            /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/.test(
                value
            )
        );
    },
    'Please enter a valid Gateway!'
);
jQuery.validator.addMethod(
    'contains',
    function (haystack, element, needle) {
        return this.optional(element) || haystack.indexOf(needle) === -1;
    },
    'Password can not contain any part of the username.'
);
jQuery.validator.addMethod(
    'loginRegex',
    function (value, element) {
        return this.optional(element) || /^[a-z]?([a-z]|\d|-|&|_){1,19}$/g.test(value);
    },
    'The Username must contain 2-20 characters, begin with a letter, and only contain lowercase letters, digits, underscore, ampersand, or hyphen.'
);
jQuery.validator.addMethod(
    'passwordRegex',
    function (value, element) {
        return this.optional(element) || /^(\w|\d){6,16}$/g.test(value);
    },
    'Password must be 6 or more characters long and not contain spaces.'
);
jQuery.validator.addMethod(
    'portalPasswordRegex',
    function (value, element) {
        return this.optional(element) || /^[^\n ]{6,32}$/g.test(value);
    },
    'Password must be 6 or more characters long and not contain spaces.'
);
